import { useContextKeycloak } from "@/app/module/keycloak/index";
import { createContext, useContext, useEffect } from "react";
import { useSystemView } from "./system-view-hooks";

type ContextSystemViewType = ReturnType<typeof useSystemView>;
export const systemViewContext = createContext<ContextSystemViewType | null>(
  null,
);

export function useContextSystemView() {
  const context = useContext(systemViewContext);

  if (!context) {
    throw new Error(
      "useContextSystemView must be used within a ContextSystemViewProvider",
    );
  }

  return context;
}

export function ContextSystemViewProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const values = useSystemView();
  const { authorize } = useContextKeycloak();
  const { systemViewState, fetchCheckSystemView } = values;

  useEffect(() => {
    if (authorize && systemViewState === "init") {
      fetchCheckSystemView();
    }
  }, [authorize, systemViewState]);

  if (authorize && systemViewState === "init") {
    return null;
  }

  return (
    <systemViewContext.Provider value={values}>
      {children}
    </systemViewContext.Provider>
  );
}
